export default __webpack_public_path__ + "static/media/signout-white.cd21eaf6.svg";